import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useTracking } from "react-tracking";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import GainfulAccordion from "Components/GainfulAccordion";
import ReactPlayer from "react-player";
import GainfulButton from "Components/GainfulButton";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { apiGetDietitian, apiGetAnswers } from "Root/api/apiProfile";
import { RDModal } from "Root/profile/utils/trackingEnums";
import DrawerComponent from "../DrawerComponent";
import styles from "./styles.module.css";
import { getFirstSessionFaqs, firstSessionFaqs, getTitle } from "./helpers";
import Loading from "../../../../checkout/components/Loading/index";
import UnderlinedButton from "../UnderlinedButton/index";
import { getPartOfSMSString } from "../../SubscriptionPageV2/utils";
const FirstSessionModal = ({ openDrawer, toggleDrawer }) => {
    const history = useHistory();
    const reduxUserName = useSelector((state) => state.user.name);
    const [loading, setLoading] = useState(true);
    const [video, setVideo] = useState();
    const [partOfSms, setPartOfSms] = useState("");
    const [dietitianFaqs, setDietitianFaqs] = useState([]);
    const [myRD, setMyRD] = useState({
        assigned_RD: "",
        has_contacted_RD: false,
        macroAnswers: null,
        macroResult: null,
    });
    const { trackEvent } = useTracking();
    const fetchRDData = async () => {
        setLoading(true);
        const data = await apiGetDietitian();
        const profileData = await apiGetAnswers();
        setMyRD(data);
        const faqs = getFirstSessionFaqs(firstSessionFaqs, profileData.modifiedAnswersObj.reasons);
        setDietitianFaqs(faqs);
        const videoMatt = "https://vimeo.com/691855615";
        const videoMary = "https://vimeo.com/691855192";
        const videoUrl = data.assigned_RD === "Mary" ? videoMary : videoMatt;
        setVideo(videoUrl);
        setLoading(false);
    };
    // tracking section for GA
    const goToRd = () => {
        trackEvent({ funComponent: "talk_to_RD_btn", event: "talk_to_RD" });
        history.push("/app/dietitian");
    };
    const trackPlayRDModalVideo = () => {
        trackEvent({ funComponent: RDModal.RD_modal_video, event: `${RDModal.RD_modal_video_played}` });
    };
    const trackPauseRDModalVideo = () => {
        trackEvent({ funComponent: RDModal.RD_modal_video, event: `${RDModal.RD_modal_video_paused}` });
    };
    const trackTextRDEvent = () => {
        trackEvent({ funComponent: RDModal.RD_modal_text_RD_btn, event: `${RDModal.text_with_your_RD}` });
    };
    const trackAccordionEvent = (item, newExpanded) => {
        const accTitle = getTitle(item, newExpanded);
        trackEvent({
            funComponent: RDModal.RD_modal_FAQ_accordion,
            event: accTitle,
        });
    };
    // tracking section for GA
    useEffect(() => {
        fetchRDData();
        const partOfString = getPartOfSMSString();
        setPartOfSms(partOfString);
    }, []);
    const isMobile = useScreenWidth() < 768;
    const textMyRdCopy = `Text ${myRD.assigned_RD}: 855-550-2006`;
    const meetRdCopy = `Meet your Registered Dietitian, ${myRD.assigned_RD} RD, LD`;
    const welcomeToGainfulCopy = `Welcome to Gainful, ${reduxUserName}!`;
    return (_jsx(DrawerComponent, { extraClassName: "firstSessionModal", crossButton: true, open: openDrawer, toggleDrawer: toggleDrawer, anchor: isMobile ? "bottom" : "top", children: _jsxs("div", { className: styles.firstSessionModal_container, children: [_jsxs("div", { className: styles.firstSessionModal_header, children: [_jsx("h1", { className: styles.firstSessionModal_title, children: _jsx("span", { children: welcomeToGainfulCopy }) }), _jsx("p", { className: styles.firstSessionModal_header_tex, children: meetRdCopy })] }), _jsx("div", { className: styles.firstSessionModal_video, children: myRD.assigned_RD && video && (_jsx(ReactPlayer, { url: video, playing: !!video, playsinline: true, config: {
                            vimeo: {
                                playerOptions: {
                                    controls: true,
                                },
                            },
                        }, onPlay: trackPlayRDModalVideo, onPause: trackPauseRDModalVideo, className: styles.firstSessionModal_videoContent })) }), _jsxs("div", { className: styles.firstSessionModal_FAQ, children: [_jsx("p", { className: styles.firstSessionModal_FAQTitle, children: "Curated FAQs" }), loading && dietitianFaqs.length !== 3 ? (_jsxs(_Fragment, { children: [_jsx(Loading, { isJustLines: true }), _jsx("div", { className: styles.firstSessionModal_FAQMargin }), _jsx(Loading, { isJustLines: true }), _jsx("div", { className: styles.firstSessionModal_FAQMargin }), _jsx(Loading, { isJustLines: true })] })) : (_jsx(GainfulAccordion, { firstSessionModal: true, firstSessionModalHeading: isMobile, firstSessionModalDescription: true, square: true, items: dietitianFaqs, trackAccordionEvent: trackAccordionEvent }))] }), _jsxs("div", { className: styles.firstSessionModal_buttonContainer, children: [_jsx("p", { className: styles.firstSessionModal_buttonText, children: "Have more questions?" }), isMobile && (_jsxs(_Fragment, { children: [_jsx("a", { role: "button", tabIndex: 0, className: styles.firstSessionModal_SMSBtn_mob, href: `sms://+18555502006${partOfSms}`, onClick: trackTextRDEvent, "data-attr": "sms-first-session-button", children: `TEXT ${myRD.assigned_RD}` }), _jsx("p", { children: textMyRdCopy }), _jsx("p", { style: { fontSize: "10px", marginBottom: "30px" }, children: "Msg and data rates may apply" })] })), isMobile ? (_jsx(UnderlinedButton, { dataAttr: "email-mobile-first-session-button", label: `EMAIL ${myRD.assigned_RD}`, onClick: goToRd })) : (_jsx(GainfulButton, { width: "165px", extraClassName: "firstSessionModal_button_mob", text: `EMAIL ${myRD.assigned_RD}`, onClick: goToRd, dataAttr: "email-first-session-button", dataTracking: undefined, disabled: undefined, type: undefined, fiftyPercentWidth: undefined }))] })] }) }));
};
export default FirstSessionModal;
